import { jsx as n } from "@emotion/react/jsx-runtime";
import { DropdownTags as v } from "./Displayer.styled.js";
import { Chip as g } from "../../../../Chip/index.js";
import { Text as T } from "../../../../Text/index.js";
import { removeOption as C } from "../../../helpers.js";
import { useMultiSelectContext as b } from "../../MultiSelectContext.js";
import { MenuListVariantEnum as i } from "../../../../../types/components/menuList.js";
const S = ({
  edit: l
}) => {
  const {
    dataTrackId: s,
    selectedValue: t,
    variantTags: c,
    onChange: m,
    variant: a,
    sections: u
  } = b(), d = (e, r) => {
    e.stopPropagation();
    const o = C(t, r);
    m(o);
  }, p = (e) => a === i.Chip ? u.find((o) => o.options.some((h) => h.value === e.value))?.color ?? "primary" : c, f = () => /* @__PURE__ */ n(v, { hasLabelOnTop: !!l, children: t.map((e) => {
    const r = p(e);
    return /* @__PURE__ */ n(g, { dataTrackId: `${s}-tag-${e.value}`, onIconAction: (o) => d(o, e), variant: r, chipShape: a === i.Chip ? "rounded" : "cube", disabled: e?.readonly ?? !1, children: /* @__PURE__ */ n(T, { color: r, variant: "bodyMMedium", oneLine: !0, children: e.label }) }, e.value);
  }) });
  return t && t.length > 0 ? f() : null;
};
export {
  S as Displayer
};
